// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import { CreateSortableListItem } from '@Molecules/CreateSortableListItem/CreateSortableListItem';
import { THForm } from '@Molecules/THForm/THForm';
import { Empty, Form, FormInstance } from 'antd';
import { ICONS } from '@Constants/iconsApp';
import { FieldBlock } from '../FieldBlock';

import { TableEntityType } from '../FormInterface';

import './ColumnField.scss';
import { ColumnFieldSelector } from './ColumnFieldSelector';

interface ColumnFieldProps {
    form: FormInstance;
    title: string;
    actionTitle: string;
    entityType: TableEntityType;
    name?: string;
}

export const ColumnField = ({ form, entityType, name = 'columns', title, actionTitle }: ColumnFieldProps) => {
    const i = useLocalMessage();
    const columns = Form.useWatch([name], form);

    return (
        <THForm.List name={name}>
            {(fields, { add, remove }) => (
                <FieldBlock
                    title={title}
                    className="case-template-columns"
                    footerAction={
                        fields.length ? (
                            <ColumnFieldSelector
                                actionTitle={actionTitle}
                                entityType={entityType}
                                selectedColumns={columns}
                                onClick={(value: string) => add(value)}
                                classes={{
                                    button: 'columns-field__add-btn',
                                    menu: 'columns-field__menu',
                                    item: 'actions-list__item',
                                }}
                            />
                        ) : null
                    }
                >
                    {!fields.length && (
                        <Empty
                            imageStyle={{ height: 60 }}
                            description={
                                <div className="columns-field__none">
                                    <span>{i('report-template.no-columns')}</span>
                                    <ColumnFieldSelector
                                        actionTitle={actionTitle}
                                        entityType={entityType}
                                        selectedColumns={columns}
                                        onClick={(value: string) => add(value)}
                                        classes={{
                                            button: 'columns-field__add-btn-empty',
                                            menu: 'columns-field__menu',
                                            item: 'actions-list__item',
                                        }}
                                        hidePlusIcon
                                    />
                                </div>
                            }
                        />
                    )}

                    {fields.map((field, index) => {
                        return (
                            <CreateSortableListItem
                                className="columns-field__drag-item"
                                title={
                                    columns ? i({ defaultMessage: columns[index], id: `column.${columns[index]}` }) : ''
                                }
                                fieldName={name}
                                key={field.key}
                                field={field}
                                index={index}
                                remove={remove}
                                form={form}
                                removeIcon={<ICONS.CloseIcon />}
                            />
                        );
                    })}
                </FieldBlock>
            )}
        </THForm.List>
    );
};
